/* eslint-disable */
const capitalize = (word) => {
  const split = word.split('');
  split[0] = word[0].toUpperCase();
  return split.join('');
};

const createMoneyFormat = (n) => {
  let int = parseInt(n);
  if ((int && typeof int === 'number') || int === 0) {
    int = parseInt(Math.round(n));
    return int.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  if (n === '-') {
    return '-$0';
  }
  if (n === undefined) {
    return '$0';
  }
  return '$0';
};

function findQuarterToDisplay() {
  let finalQuarter = [];
  const q1 = [1, 2, 3];
  const q2 = [4, 5, 6];
  const q3 = [7, 8, 9];
  const q4 = [10, 11, 12];
  const currentMonth = new Date().getMonth() + 1; // JS months are 0-indexed

  if (currentMonth < 3) {
    finalQuarter = q4;
  }
  if (currentMonth >= 3 && currentMonth < 6) {
    finalQuarter = q1;
  }
  if (currentMonth >= 6 && currentMonth < 9) {
    finalQuarter = q2;
  }
  if (currentMonth >= 9 && currentMonth < 12) {
    finalQuarter = q3;
  }
  return finalQuarter;
}

const generateId = () => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  for (let i = 0; i < 5; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

function parseMoney(n, noRounding = false) {
  let int = parseInt(n);
  if ((int && typeof int === 'number') || int === 0) {
    if (noRounding) {
      return n.toLocaleString(undefined, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    int = parseInt(Math.round(n));
    return int.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  if (n === undefined || n === null) {
    return '';
  }
  return '-';
}

function parseMoneyNoDollar(n, noRounding = false) {
  let int = parseInt(n);
  if ((int && typeof int === 'number') || int === 0) {
    if (noRounding) {
      return n.toLocaleString(undefined, {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    int = parseInt(Math.round(n));
    return int.toLocaleString(undefined, {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  if (n === undefined || n === null) {
    return '';
  }
  return '-';
}

const formatAccountingNumber = (n, options = { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 2 }) => {
  if (typeof n !== 'number') {
    n = parseFloat(n);
    if (isNaN(n)) return '';
  }

  const { showDollarSign, parenthesesForNegatives, round, decimalPlaces } = options;

  // Round number if requested
  const value = round ? Number(n.toFixed(decimalPlaces)) : n;

  // Format number with commas and decimals
  let formattedNumber = Math.abs(value).toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  });

  // Wrap negative numbers in parentheses if requested
  if (value < 0 && parenthesesForNegatives) {
    formattedNumber = `(${formattedNumber})`;
  }

  // Add dollar sign if requested
  if (showDollarSign) {
    formattedNumber = `$${formattedNumber}`;
  }

  return formattedNumber;
}

const percentify = (val, muliplier = 1) => {
  if (val || val === 0) {
    return `${(Math.round(val * 100) / 100) * muliplier}%`;
  }
  return '0%';
};

const percentRounded = (val, muliplier = 1, parenthesesForNegatives = false) => {
  if (muliplier == 1) {
    if (val || val === 0) {
      if (parenthesesForNegatives) {
        return val < 0 ? `(${Math.round((Math.round(Math.abs(val) * 100) / 100)) * muliplier})%`: `${Math.round((Math.round(val * 100) / 100)) * muliplier}%`;
      } else {
        return val < 0 ? `${Math.round((Math.round(Math.abs(val) * 100) / 100)) * muliplier}%`: `${Math.round((Math.round(val * 100) / 100)) * muliplier}%`;
      }
    }
  }

  if (muliplier == 100) {
    if (val || val === 0) {
      if (parenthesesForNegatives) {
        return val < 0 ? `(${Math.round(Math.abs(val) * 100)})%`: `${Math.round(val * 100)}%`;
      } else {
        return val < 0 ? `${Math.round(Math.abs(val) * 100)}%`: `${Math.round(val * 100)}%`;
      }
    }
  }
  return '0%';
};

const usStates = [
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Louisiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Puerto Rico', 'PR'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['USA', 'USA'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY']
]

export { capitalize };
export { createMoneyFormat };
export { findQuarterToDisplay };
export { generateId };
export { parseMoney };
export { parseMoneyNoDollar };
export { percentify };
export { formatAccountingNumber };
export { percentRounded };
export { usStates };
